<template>
  <div>
    <b-row>
      <b-col md="12">
        <b-card no-body>
          <b-tabs v-model="activeTab" card class="nav-fill">
            <b-tab v-for="(info, name) in tabInfo" :key="name" :title="info.title" @click="changeTab(name)">
              <MainManagementList v-if="currentTab == name" :currentTab="currentTab" :fieldobj="fieldobj"/>
            </b-tab>
          </b-tabs>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import MainManagementList from './component/MainManagementList';
import { EventBus } from '../../event-bus';
import Breadcrumb from '../../../components/Breadcrumb';

export default {
  name:'MainManagement',
  components: {
    MainManagementList,
    Breadcrumb,
    EventBus,
  },
  data() {
    return {

      activeTab: null,
      currentTab: 'keyvisual',

      tabInfo: {
        keyvisual: {title: '키비쥬얼'},
        curation: {title: '큐레이션'},
        banner01: {title: '배너 01'},
        banner02: {title: '배너 02'},
        banner03: {title: '배너 03'},
      },

      fieldobj: {
        fieldItems: [{
          'selectcheck': {
            'label': '선택', 'class': 'text-center', 'tdClass': 'text-vmiddle',
            'thStyle': {'vertical-align': 'middle'},
            'headerTitleSlot': 'selectcheck',
          }
        }, {
          'rnum': {
            'label': '번호',
            'class': 'text-center',
            'thStyle': {'vertical-align': 'middle'}
          }
        }, {
          'active_yn': {
            'label': '활성화',
            'class': 'text-center',
            'thStyle': {'vertical-align': 'middle'}
          }
        }, {
          'slot_number': {
            'label': '슬롯번호',
            'class': 'text-center',
            'thStyle': {'vertical-align': 'middle', 'text-align': 'center', 'width':'100px'}
          }
        }, {
          'postsubject': {
            'label': '제목',
            'class': 'text-left',
            'thStyle': {'vertical-align': 'middle', 'text-align': 'center'}
          }
        }, {
          'bannerdate': {
            'label': '활성기간',
            'class': 'text-center',
            'thStyle': {'vertical-align': 'middle'}
          }
        }, {
          'reg_name': {
            'label': '최총 등록자',
            'class': 'text-center',
            'thStyle': {'vertical-align': 'middle'}
          }
        } , {
          'reg_date': {
            'label': '등록일',
            'class': 'text-center',
            'thStyle': {'vertical-align': 'middle'}
          }
        }],
        dateMonthButtons: [
          { item_name: '전체', item_code:'dayall', state: true },
          //{ item_name: '오늘', item_code:'-1|days',state: false },
          { item_name: '1주일', item_code:'-7|days',state: true },
          { item_name: '1개월', item_code:'-1|months',state: false },
          { item_name: '6개월', item_code:'-6|months',state: false },
          { item_name: '1년', item_code:'-1|years',state: false },
        ],
        calendarLocale: {
          "format": "YYYY-MM-DD",
          "separator": "~",
          "applyLabel": "적용",
          "cancelLabel": "취소",
          "fromLabel": "From",
          "toLabel": "To",
          "customRangeLabel": "Custom",
          "weekLabel": "W",
          "daysOfWeek": [
            "일", "월", "화", "수", "목", "금", "토"
          ],
          "monthNames": [
            "1월", "2월", "3월", "4월", "5월", "6월",
            "7월", "8월", "9월", "10월", "11월", "12월"
          ],
          "firstDay": 1
        },
      }

    }
  },
  watch: {
  },
  mounted: function() {
    var self = this;

    //등록, 수정으로 페이지 진입시 banner_type session 확인
    //있다면 queryParams.banner_type에 할당
    setTimeout(function() {
      if (typeof self.$session.get('page_banner_type') != 'undefined') {
        self.currentTab = self.$session.get('page_banner_type');

        //관리별 b-tabs 활성화
        let keys = Object.keys(self.tabInfo);
        let index = keys.indexOf(self.currentTab);
        self.activeTab = index;
      }
      self.changeTab(self.currentTab);
    }, 100);
  },

  methods: {

    //탭 변경
    changeTab (newTap) {
      // 마지막 메뉴명 변경을 위한 이벤트 버스 추가
      this.$session.set('page_banner_type', newTap);
      this.currentTab = newTap;
      const breadcrumbName = '메인페이지 / '+this.tabInfo[this.currentTab].title;
      EventBus.$emit('change-last-breadcrumb-name',breadcrumbName);
    },
  },

  beforeDestroy() {
    //페이지 이탈시 breadcrumb 커스텀 초기화
    EventBus.$emit('reset-last-breadcrumb-name');
  },
}
</script>



// WEBPACK FOOTER //
// src/views/site/main/MainManagement.vue